<script>
import { mapState } from "vuex";
import { api } from "@/state/services";
import { maskCpf, validateCpf } from "@/utils/masks";

export default {
  data() {
    return {
      showModal: false,
      cpf: "",
      triedSubmit: false,
      loading: false,
      error: "",
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    mustFillCpf() {
      const user = this.account && this.account.user;
      return !!user && Number(user.regional) === 1 && !user.cpf_regional;
    },
    cpfState() {
      if (!this.triedSubmit) return null;
      return validateCpf(this.cpf);
    },
  },
  watch: {
    mustFillCpf: {
      immediate: true,
      handler(val) {
        this.showModal = val;
      },
    },
  },
  methods: {
    maskCpf,
    submit() {
      this.triedSubmit = true;
      this.error = "";

      if (!validateCpf(this.cpf)) {
        return;
      }

      this.loading = true;
      api
        .put("user/cpf-regional", { cpf: this.cpf })
        .then((response) => {
          if (response.data.status === "success") {
            const user = { ...this.account.user, cpf_regional: this.cpf.replace(/\D/g, "") };
            this.$store.state.account.user = user;
            localStorage.setItem("user", JSON.stringify(user));
            this.showModal = false;
          } else {
            this.error = response.data.message || "Não foi possível salvar o CPF.";
          }
        })
        .catch(() => {
          this.error = "Não foi possível salvar o CPF. Tente novamente.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<template>
  <b-modal
    v-model="showModal"
    title="Confirme seu CPF"
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    centered
  >
    <p>
      Olá, <strong>{{ account.user && account.user.name }}</strong> Precisamos que você
      nos informe qual o seu CPF para que possamos vincular a sua regional ao seu usuario
      de Consultor é de suma importancia que você informe o seu CPF corretamente pois pode
      implicar na conversão de Leads dos afiliados e outros processos internos do sistema.
    </p>

    <div v-if="error" class="alert alert-danger py-2 small">{{ error }}</div>

    <b-form @submit.prevent="submit">
      <b-form-group label="CPF">
        <b-form-input
          :value="cpf"
          :state="cpfState"
          placeholder="000.000.000-00"
          inputmode="numeric"
          autocomplete="off"
          @input="cpf = maskCpf($event)"
        ></b-form-input>
        <b-form-invalid-feedback>Informe um CPF válido.</b-form-invalid-feedback>
      </b-form-group>

      <div class="d-flex justify-content-end mt-3">
        <b-button type="submit" variant="primary" :disabled="loading">
          <b-spinner v-if="loading" small class="mr-1"></b-spinner>
          Salvar
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>
